import "./../../About/OurStory/OurStory.css";
//import "./Disclaimer.css";
import { Container, Col, Row } from "react-bootstrap";

function ReferralProgramPolicy() {
  
  return (
    <>
      <section className="our-story-block disclaimer termcondition_page">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }}>
              <div className="our-story-inner arrow-main">
                <h2>Referral Program Policy </h2>
                <h3 className="pb-3">Eligibility & Applicability </h3>
              <ul className="pb-3">
                <li className="pb-2">This offer is valid only for  Moneysukh clients 
                  (excluding Authorized Partners and Business Development Representatives).</li>

                  <li className="pb-2">
                    The scheme is effective from July 1, 2025.
                  </li>

                  <li className="pb-2">The offer cannot be combined with any other promotions or offers</li>
                <li className="pb-2">Any disputes/grievances arising out of refer & earn program will not be covered under investor protection or grievance redressal measures of the Exchange.</li>
                 
              </ul>
                
                 <h3 className="pb-3">
                  Prohibited Activities
                </h3>
               <ul className="pb-3">
                   <li className="pb-2">Any form of fraud, attempted fraud, abuse of the referral program, or violation of these terms is strictly prohibited</li>
                   <li className="pb-2">All trading must be organic; sharing user IDs, passwords, or OTPs, or engaging in intentional trading solely for revenue generation, is not allowed.</li>
                </ul>

                 <h3 className="pb-3">
                  Referral Bonus
                </h3>
               <ul className="pb-3">
                   <li className="pb-2">You will received a one-time referral reward of Rs 50 per referral + upto 50% Commission (Brokerage Sharing)* for First 3 Months for each new client you refer, credited to your trading account. From the 4th Month it will be 20% Brokerage Sharing</li>
                    <li className="pb-2">Referral commissions will be credited directly to your trading account on the 15th of next month</li>
                     <li className="pb-2">Please note that any account opened under any referral schemes for referral commissions must be subject to either Plan A* or Plan B*.</li>
                </ul>

               <h3 className="pb-3">General Terms</h3>
               <ul className="pb-3">
                   <li className="pb-2">Moneysukh reserves the right to amend or withdraw the offer and its terms at any time without prior notice. All decisions by Moneysukh regarding the scheme are final and binding</li>
                   <li className="pb-2">Updates to the scheme will be communicated via Moneysukh website/ mobile app and registered email addresses</li>
                </ul>

               <h3 className="pb-3">Grievances</h3>
               <ul className="pb-3">
                   <li className="pb-2">For any queries or grievances related to this scheme, please <br/> contact: support@moneysukh.com</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </>
  );
}
export default ReferralProgramPolicy;
